import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { mediaUrl } from "@/lib/api";
import { cn } from "@/lib/utils";

export const Logo = ({ light = false, testId = "site-logo" }) => {
  const { settings } = useSite();
  const name = (settings?.brand_name || "Own Brand Technologies").toUpperCase();
  return (
    <Link to="/" className="flex items-center gap-2.5" data-testid={testId} aria-label={`${name} home`}>
      {settings?.logo_url ? (
        <img src={mediaUrl(settings.logo_url)} alt={name} className="h-10 w-auto" />
      ) : (
        <>
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-indigo-brand font-heading text-sm font-extrabold text-cta shadow-md">OB</span>
          <span className={cn("font-heading text-[15px] font-extrabold leading-tight tracking-tight sm:text-base", light ? "text-white" : "text-navy")}>
            {name.split(" ").slice(0, 2).join(" ")}
            <span className={cn("block text-[10px] font-bold tracking-[0.28em]", light ? "text-sky" : "text-ocean")}>{name.split(" ").slice(2).join(" ")}</span>
          </span>
        </>
      )}
    </Link>
  );
};
